export enum ScanModule {
  Horizon = 'HORIZON',
  Nessus = 'NESSUS',
  Decareto = 'DECARETO',
  BreachLense = 'BREACH_LENSE',
  Identeco = 'IDENTECO',
}

export namespace ScanModule {
  export function mapFromApiValue(scanModule: string): ScanModule {
    const scanModules: Record<string, ScanModule> = {
      ['HORIZON']: ScanModule.Horizon,
      ['NESSUS']: ScanModule.Nessus,
      ['DECARETO']: ScanModule.Decareto,
      ['BREACH_LENSE']: ScanModule.BreachLense,
      ['IDENTECO']: ScanModule.Identeco,
    };
    return scanModules[scanModule];
  }
}
